export default __webpack_public_path__ + "static/media/left.59c24e64.jpg";